import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Box,
  Stack,
  Typography,
  Link,
  useMediaQuery,
} from '@mui/material';
import { styled, Theme, useTheme } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import CallIcon from '@mui/icons-material/Call';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { NavLink } from 'react-router-dom';
import { AppColors } from '../utils/utils';
import useToggle from '../hooks/useToggle';
import GetStartedModel from './models/GetStartedModel';
import BookDemoFormModel from './models/BookDemoFormModel';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const GradientButton = styled(Button)(({ theme }: { theme: Theme }) => ({
  width: 'fit-content',
  height: 42,
  background: AppColors.aiGradient3,
  borderRadius: '12px',
  border: 0,
  color: 'white',
  padding: '10px 32px',
  minWidth: 0, // default for xs
  // Responsive override for md and up
  [theme.breakpoints.up('md')]: {
    minWidth: '170px',
  },
  textTransform: 'none',
  fontSize: 'clamp(0.8rem, 2vw, 1.2rem)',
  fontWeight: 500,
  boxShadow: 'none',
  textAlign: 'center',
  transition: '0.3s',
  '&:hover': {
    boxShadow: '0 6px 15px rgba(0, 0, 0, 0.3)',
    background: AppColors.aiGradient3,
  },
}));

export const navItems = [
  // { label: 'Inventory', path: '/inventory' },
  { label: 'New', path: '/new-inventory' },
  { label: 'Pre-Owned', path: '/pre-owned-inventory' },
  { label: 'Finance', path: '/finance' },
  { label: 'Service', path: '/service' },
];

const Header: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const {
    toggle: toggleGetStartedModel,
    // onOpen: onOpenGetStartedModel,
    onClose: onCloseGetStartedModel,
  } = useToggle();

  const {
    toggle: toggleRequestDemoModel,
    // onOpen: onOpenRequestDemoModel,
    onClose: onCloseRequestDemoModel,
  } = useToggle();

  // const [searchTerm, setSearchTerm] = useState<string>('');

  // // Handle the change of the input field
  // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setSearchTerm(event.target.value);
  // };

  return (
    <>
      <AppBar position='sticky' sx={{ backgroundColor: 'white' }}>
        <Stack
          gap={0.8}
          // sx={{
          //   display: 'flex',
          //   flexDirection: { xs: 'row', sm: 'row' },
          //   justifyContent: 'end',
          //   alignItems: 'end',
          //   color: 'black',
          //   py: 0.3,
          //   pr: { xs: 2, sm: 4 },
          // }}
          direction={{ xs: 'row', sm: 'row' }}
          sx={{
            flexWrap: 'wrap',
            justifyContent: { xs: 'flex-end', sm: 'flex-end' },
            alignItems: 'center',
            color: 'black',
            py: 0.3,
            pr: { xs: 1, sm: 4 },
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: { xs: 0, sm: 0.5 },
              flex: { xs: 1, sm: 'none' },
              minWidth: 0,
            }}
          >
            <CallIcon
              color='primary'
              // fontSize={'small'}
              sx={{
                width: { xs: '0.75em', sm: '1em' },
                height: { xs: '0.75em', sm: '1em' },
              }}
            />
            <Typography variant='caption' noWrap>
              <Link
                href='tel:9474475656'
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' },
                  fontSize: { xs: '10px', sm: '12px' },
                }}
              >
                947-447-5656
              </Link>
            </Typography>
            <CallIcon
              color='primary'
              // fontSize={'small'}
              sx={{
                width: { xs: '0.75em', sm: '1em' },
                height: { xs: '0.75em', sm: '1em' },
                ml: { xs: 0.5, sm: 2 },
              }}
              // sx={{}}
            />
            <Typography variant='caption' noWrap>
              <Link
                href='tel:9474473054'
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' },
                  fontSize: { xs: '10px', sm: '12px' },
                }}
              >
                947-447-3054
              </Link>
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              flexShrink: 0,
            }}
          >
            <LocationOnIcon
              color='primary'
              // fontSize={'small'}
              sx={{
                width: { xs: '0.75em', sm: '1em' },
                height: { xs: '0.75em', sm: '1em' },
              }}
            />
            <Typography
              variant='caption'
              noWrap={isMobile ? true : false}
              sx={{ maxWidth: { xs: '120px', sm: 'none' } }}
            >
              <Link
                href='https://www.google.com/maps/search/?api=1&query=1255+Maplelawn+Drive,+Troy+MI+48084'
                target='_blank'
                sx={{
                  color: 'inherit',
                  textDecoration: 'none',
                  '&:hover': { textDecoration: 'underline' },
                  fontSize: { xs: '0.65rem', sm: 'inherit' },
                }}
              >
                1255 Maplelawn Drive, Troy MI 48084
              </Link>
            </Typography>
          </Box>
        </Stack>
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: 'black',
            py: 0.7,
          }}
        >
          {/* Logo */}
          <Box
            component={Link}
            href='/'
            // href='https://qrdemos.com'
            // target='_blank'
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              textDecoration: 'none',
            }}
          >
            <Box
              component='img'
              src='/static/images/sterling_cadillac_logo.png'
              alt='QR Demos Logo'
              sx={{ height: { xs: 35, md: 60 } }}
            />
          </Box>

          {/* Right side (Sign in + Mobile menu) */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            {/* Desktop Menu */}
            <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2 }}>
              {navItems
                // .filter((item) => item.path !== location.pathname)
                .map((item) => (
                  <Button
                    key={item.label}
                    component={NavLink}
                    to={item.path}
                    sx={{
                      // color: AppColors.blueTextColor,
                      color: AppColors.whiteColor,
                      fontSize: 'clamp(0.8rem, 1.2vw, 1.2rem)',
                      textTransform: 'none',
                      '&.active': {
                        fontWeight: 'bold',
                      },
                    }}
                  >
                    {item.label}
                  </Button>
                ))}
            </Box>

            {/* <Box sx={{ ml: 2 }}>
              <TextField
                placeholder='Search Inventory'
                variant='outlined'
                value={searchTerm}
                onChange={handleChange}
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <SearchIcon sx={{ color: 'white' }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '25px',
                    color: 'white',

                    // Reduce input padding (top-bottom)
                    paddingY: '2px', // You can adjust (2px–6px recommended)

                    '& input': {
                      padding: '6px 12px', // inner input padding
                    },

                    // Default border always white
                    '& fieldset': {
                      borderColor: 'white',
                    },

                    // Hover border
                    '&:hover fieldset': {
                      borderColor: 'white',
                    },

                    // Focused border
                    '&.Mui-focused fieldset': {
                      borderColor: 'white',
                    },
                  },

                  // Placeholder styling
                  '& .MuiInputBase-input::placeholder': {
                    color: AppColors.greyOrange,
                    opacity: 1,
                    textAlign: 'center',
                  },
                }}
              />
            </Box> */}

            {/* Mobile Menu Button */}
            <IconButton
              aria-label='menu'
              sx={{
                display: { xs: 'flex', md: 'none' },
                backgroundColor: 'white',
                color: 'black',
                borderRadius: '12px',
                ml: 1,
                height: 36, // match Sign In button height
                width: 36, // make it a square
              }}
              onClick={() => setMobileOpen(true)}
            >
              <MenuIcon />
            </IconButton>

            {/* Drawer for Mobile */}
            <Drawer
              anchor='right'
              open={mobileOpen}
              onClose={() => setMobileOpen(false)}
            >
              <List sx={{ width: 200 }}>
                {navItems
                  // .filter((item) => item.path !== location.pathname)
                  .map((item) => (
                    <ListItem key={item.label} disablePadding>
                      <ListItemButton
                        component={NavLink}
                        to={item.path}
                        onClick={() => setMobileOpen(false)}
                        sx={{
                          color: AppColors.primaryColor,
                          fontSize: 'clamp(0.8rem, 1.2vw, 1.2rem)',
                          '&.active': {
                            fontWeight: 'bold',
                          },
                        }}
                      >
                        <ListItemText primary={item.label} />
                      </ListItemButton>
                    </ListItem>
                  ))}
              </List>
            </Drawer>
          </Box>
        </Toolbar>
      </AppBar>

      <GetStartedModel
        onClose={onCloseGetStartedModel}
        toggle={toggleGetStartedModel}
        onSubmitSuccess={() => {}}
      />

      <BookDemoFormModel
        onClose={onCloseRequestDemoModel}
        toggle={toggleRequestDemoModel}
        onSubmitSuccess={() => {}}
      />
    </>
  );
};

export default Header;
